// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"98965872","562":"a88ec45e"}[chunkId] + ".chunk.css";
};